const updateIsChooseTemplateTileView = (state, action) => {
  const { isChooseTemplateTileView } = action.payload;
  return {
    ...state,
    isChooseTemplateTileView,
  };
};

const updateActiveView = (state, action) => {
  const { activeView } = action.payload;
  return {
    ...state,
    activeView,
  };
};

const updateActiveTemplate = (state, action) => {
  const { templateId, templateName } = action.payload;
  return {
    ...state,
    activeTemplate: {
      templateId,
      templateName,
    },
  };
};

const updateSelectedInsurers = (state, action) => ({
  ...state,
  selectedInsurers: action.payload,
});

export const mainReducers = {
  EMAIL_TEMPLATES_UPDATE_IS_CHOOSE_TEMPLATE_TILE_VIEW:
    updateIsChooseTemplateTileView,
  EMAIL_TEMPLATES_UPDATE_ACTIVE_VIEW: updateActiveView,
  EMAIL_TEMPLATES_UPDATE_ACTIVE_TEMPLATE: updateActiveTemplate,
  EMAIL_TEMPLATES_UPDATE_SELECTED_INSURERS: updateSelectedInsurers,
};

export default mainReducers;
